import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useUserRoleCapabilities } from '@stores';
import { USER_ROLE_CAPABILITIES_QUERY_KEYS, UserRoleCapabilitiesQueries } from '../query';
import type { GetUserRoleCapabilitiesQueryData } from '../types';

type UseUserRoleCapabilitiesQueryOptions = Omit<
  UseQueryOptions<GetUserRoleCapabilitiesQueryData, Error>,
  'queryKey' | 'queryFn'
>;

export const loadUserRoleCapabilities = async (): Promise<GetUserRoleCapabilitiesQueryData> => {
  const { setUserRoleCapabilities, clearUserRoleCapabilities } = useUserRoleCapabilities.getState();

  const data = await UserRoleCapabilitiesQueries.getUserRoleCapabilities();

  if (!data) {
    clearUserRoleCapabilities();
    return null;
  }

  setUserRoleCapabilities(data.role, data.capabilities);

  return data;
};

export const useUserRoleCapabilitiesQuery = (options?: UseUserRoleCapabilitiesQueryOptions) => {
  return useQuery<GetUserRoleCapabilitiesQueryData, Error>({
    queryKey: [USER_ROLE_CAPABILITIES_QUERY_KEYS.GET_USER_ROLE_CAPABILITIES],
    queryFn: loadUserRoleCapabilities,
    ...options,
  });
};
